const dateMappings = {
  '2000-01-01': {
    index: 0,
    month: 'Jan',
    isFirstOfMonth: true,
  },
  '2000-01-15': {
    index: 1,
    month: 'Jan',
    isFirstOfMonth: false,
  },
  '2000-02-01': {
    index: 2,
    month: 'Feb',
    isFirstOfMonth: true,

  },
  '2000-02-15': {
    index: 3,
    month: 'Feb',
    isFirstOfMonth: false,
  },
  '2000-03-01': {
    index: 4,
    month: 'Mar',
    isFirstOfMonth: true,

  },
  '2000-03-15': {
    index: 5,
    month: 'Mar',
    isFirstOfMonth: false,
  },
  '2000-04-01': {
    index: 6,
    month: 'Apr',
    isFirstOfMonth: true,

  },
  '2000-04-15': {
    index: 7,
    month: 'Apr',
    isFirstOfMonth: false,
  },
  '2000-05-01': {
    index: 8,
    month: 'Mei',
    isFirstOfMonth: true,

  },
  '2000-05-15': {
    index: 9,
    month: 'Mei',
    isFirstOfMonth: false,
  },
  '2000-06-01': {
    index: 10,
    month: 'Jun',
    isFirstOfMonth: true,

  },
  '2000-06-15': {
    index: 11,
    month: 'Jun',
    isFirstOfMonth: false,
  },
  '2000-07-01': {
    index: 12,
    month: 'Jul',
    isFirstOfMonth: true,

  },
  '2000-07-15': {
    index: 13,
    month: 'Jul',
    isFirstOfMonth: false,
  },
  '2000-08-01': {
    index: 14,
    month: 'Aug',
    isFirstOfMonth: true,

  },
  '2000-08-15': {
    index: 15,
    month: 'Aug',
    isFirstOfMonth: false,
  },
  '2000-09-01': {
    index: 16,
    month: 'Sep',
    isFirstOfMonth: true,

  },
  '2000-09-15': {
    index: 17,
    month: 'Sep',
    isFirstOfMonth: false,
  },
  '2000-10-01': {
    index: 18,
    month: 'Okt',
    isFirstOfMonth: true,

  },
  '2000-10-15': {
    index: 19,
    month: 'Okt',
    isFirstOfMonth: false,
  },
  '2000-11-01': {
    index: 20,
    month: 'Nov',
    isFirstOfMonth: true,

  },
  '2000-11-15': {
    index: 21,
    month: 'Nov',
    isFirstOfMonth: false,
  },
  '2000-12-01': {
    index: 22,
    month: 'Dec',
    isFirstOfMonth: true,

  },
  '2000-12-15': {
    index: 23,
    month: 'Dec',
    isFirstOfMonth: false,

  },
  '2001-01-01': {
    index: 24,
    month: 'Jan',
    isFirstOfMonth: true,

  },
};

export default dateMappings;
